<template>
  <div class="session-box session-box-recording">
    <div class="d-flex flex-column flex-md-row">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-center session-box-first-line no-favourite">
          <i class="isax isax-calendar-1"/>
          <span class="session-start-date flex-grow-1">
            <span>{{ recording.startTime | moment("D MMM YYYY") }}</span>
            <span>{{ recording.startTime | moment("HH:mma") }}</span>
          </span>
        </div>
        <div class="d-flex flex-column flex-md-row align-items-md-center session-box-info-lines">
          <div class="recording-title">
            <span>{{ recording.name }}</span>
          </div>
        </div>
        <div class="d-flex flex-column flex-md-row align-items-md-center session-box-info-lines">
          <div class="session-duration">
            <i class="isax isax-timer-1"/>
            <span>{{ $t("recordings.duration") }}: {{ recordingDuration }} {{ $t("sessions.min") }}</span>
          </div>
          <div class="session-host" v-if="hostName">
            <i class="isax isax-profile-circle"/>
            <span>{{ $t("sessions.host") }}: {{ hostName }}</span>
          </div>
        </div>
        <div v-if="classroom.description && classroom.description.trim()" class="session-box-info-lines mt-1">
          <span>{{ $t("sessions.notes") }}</span>
          <span>{{ classroom.description }}</span>
        </div>
      </div>
    </div>
    <div class="session-controls">
      <div class="d-flex flex-column flex-md-row align-items-center ml-md-auto session-controls-buttons">
        <button class="page-controls__primary-action button primary short" @click="launchClickUrl('_blank', recording)">
          <i class="isax isax-play" v-if="!recording.loadingLaunchUrl || recording.launchUrl"></i>
          <loading-icon class="svg-icon small default rotate" :size="24" v-if="recording.loadingLaunchUrl"/>
          <span>{{ $t("sessions.viewrecording") }}</span>
        </button>
        <b-dropdown v-if="recording.canDownload"
                    right menu-class="button-list-icons small-icons"
                    variant=" button secondary mb-0 ml-2 d-flex align-items-center"
                    toggle-class="text-decoration-none">
          <template :id="'download-options-recording-' + recording.id" #button-content>
            <i class="isax isax-import-1"></i>
            <span>{{ $t("recordings.downloads") }}</span>
          </template>
          <b-dropdown-item-btn @click="getDownloadLinkClick(recording)" link-class="button">
            <span>{{ $t("recordings.downloadsession") }}</span>
          </b-dropdown-item-btn>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingIcon from 'vue-material-design-icons/Loading.vue'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import recordingPlaybackMixin from '../../../mixins/recordingPlaybackMixin'

// EdF: Tarjeta de grabación de Adobe Connect. A diferencia de SessionCard, una sala CONNECT es una
// única clase reutilizada N veces, por lo que cada grabación se muestra como una fila propia.
// CONNECT no persiste sus grabaciones (se piden en vivo a la API de Adobe Connect), así que no hay
// marca de vista, ni asistencia, ni favoritos, ni reproductor interno: sólo los datos y el enlace.
export default {
  name: 'ConnectRecordingCard',
  components: { LoadingIcon },
  mixins: [utilitiesMixin, recordingPlaybackMixin],
  props: {
    recording: { type: Object, required: true },
    classroom: { type: Object, required: true }
  },
  computed: {
    hostName () {
      const host = this.classroom && this.classroom.host
      return (host && host.fullName) || null
    },
    recordingDuration () {
      // La duración de CONNECT llega en milisegundos (ver ConnectClassroomManager)
      const minutes = Math.round((this.recording.duration || 0) / 60000)
      return String(minutes).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/SessionsComponents/ConnectRecordingCard.vue